export default __webpack_public_path__ + "static/media/exam-details-header.2da977db.jpg";